import React from 'react';
import styled from 'styled-components';
import Button from '@mui/material/Button';
import OpenInFullIcon from '@mui/icons-material/OpenInFull';

interface Props {
    onResetView: () => void;
}

const SectionHeader = ({ onResetView }: Props) => {
    return (
        <SectionHeaderContainer>
            <SectionHeaderText>Segments</SectionHeaderText>
            <Button
                size="small"
                variant="outlined"
                onClick={onResetView}
                startIcon={<OpenInFullIcon />}
            >
                Reset View
            </Button>
        </SectionHeaderContainer>
    );
};

const SectionHeaderContainer = styled.div`
    padding: 8px 12px;
    border-radius: 4px;
    background-color: #eef0f2;
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

const SectionHeaderText = styled.h4`
    color: #697d90;
    font-size: 11px;
    font-weight: 700;
    line-height: 15px; /* 136.364% */
    letter-spacing: 0.5px;
    text-transform: uppercase;
    margin: 0;
`;

export default SectionHeader;
